/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseAppearanceFieldLayout } from './DatabaseAppearanceFieldLayout';
import {
    DatabaseAppearanceFieldLayoutFromJSON,
    DatabaseAppearanceFieldLayoutFromJSONTyped,
    DatabaseAppearanceFieldLayoutToJSON,
} from './DatabaseAppearanceFieldLayout';
import type { DatabaseColumnLayout } from './DatabaseColumnLayout';
import {
    DatabaseColumnLayoutFromJSON,
    DatabaseColumnLayoutFromJSONTyped,
    DatabaseColumnLayoutToJSON,
} from './DatabaseColumnLayout';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseFieldGroup
 */
export interface DatabaseFieldGroup {
    /**
     * 
     * @type {string}
     * @memberof DatabaseFieldGroup
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseFieldGroup
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseFieldGroup
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseFieldGroup
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseFieldGroup
     */
    backgroundColor?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseFieldGroup
     */
    showIfEmpty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseFieldGroup
     */
    hideName?: boolean;
    /**
     * 
     * @type {DatabaseColumnLayout}
     * @memberof DatabaseFieldGroup
     */
    groupColumnLayout?: DatabaseColumnLayout;
    /**
     * 
     * @type {DatabaseAppearanceFieldLayout}
     * @memberof DatabaseFieldGroup
     */
    fieldLayout?: DatabaseAppearanceFieldLayout;
    /**
     * 
     * @type {string}
     * @memberof DatabaseFieldGroup
     */
    nameAlignment?: DatabaseFieldGroupNameAlignmentEnum;
    /**
     * 
     * @type {Array<DatabaseFieldVisibilityRule>}
     * @memberof DatabaseFieldGroup
     */
    visibilityRules?: Array<DatabaseFieldVisibilityRule>;
}


/**
 * @export
 */
export const DatabaseFieldGroupNameAlignmentEnum = {
    Left: 'LEFT',
    Center: 'CENTER',
    Right: 'RIGHT'
} as const;
export type DatabaseFieldGroupNameAlignmentEnum = typeof DatabaseFieldGroupNameAlignmentEnum[keyof typeof DatabaseFieldGroupNameAlignmentEnum];


/**
 * Check if a given object implements the DatabaseFieldGroup interface.
 */
export function instanceOfDatabaseFieldGroup(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseFieldGroupFromJSON(json: any): DatabaseFieldGroup {
    return DatabaseFieldGroupFromJSONTyped(json, false);
}

export function DatabaseFieldGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseFieldGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'backgroundColor': !exists(json, 'backgroundColor') ? undefined : json['backgroundColor'],
        'showIfEmpty': !exists(json, 'showIfEmpty') ? undefined : json['showIfEmpty'],
        'hideName': !exists(json, 'hideName') ? undefined : json['hideName'],
        'groupColumnLayout': !exists(json, 'groupColumnLayout') ? undefined : DatabaseColumnLayoutFromJSON(json['groupColumnLayout']),
        'fieldLayout': !exists(json, 'fieldLayout') ? undefined : DatabaseAppearanceFieldLayoutFromJSON(json['fieldLayout']),
        'nameAlignment': !exists(json, 'nameAlignment') ? undefined : json['nameAlignment'],
        'visibilityRules': !exists(json, 'visibilityRules') ? undefined : ((json['visibilityRules'] as Array<any>).map(DatabaseFieldVisibilityRuleFromJSON)),
    };
}

export function DatabaseFieldGroupToJSON(value?: DatabaseFieldGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'color': value.color,
        'backgroundColor': value.backgroundColor,
        'showIfEmpty': value.showIfEmpty,
        'hideName': value.hideName,
        'groupColumnLayout': DatabaseColumnLayoutToJSON(value.groupColumnLayout),
        'fieldLayout': DatabaseAppearanceFieldLayoutToJSON(value.fieldLayout),
        'nameAlignment': value.nameAlignment,
        'visibilityRules': value.visibilityRules === undefined ? undefined : ((value.visibilityRules as Array<any>).map(DatabaseFieldVisibilityRuleToJSON)),
    };
}

